<div class="flex h-full">
  <!-- Menú lateral -->
  <div class="w-60 border-r border-gray-300 p-4 space-y-2 bg-gray-50">
    <button
      class="w-full text-left px-4 py-2 rounded-md"
      [class.bg-blue-500]="activeSection === 'usuario'"
      [class.text-white]="activeSection === 'usuario'"
      (click)="setActive('usuario')">
      Permisos por usuario
    </button>

    <button
      class="w-full text-left px-4 py-2 rounded-md"
      [class.bg-blue-500]="activeSection === 'perfil'"
      [class.text-white]="activeSection === 'perfil'"
      (click)="setActive('perfil')">
      Permisos por perfil
    </button>

    <button
      class="w-full text-left px-4 py-2 rounded-md"
      [class.bg-blue-500]="activeSection === 'generales'"
      [class.text-white]="activeSection === 'generales'"
      (click)="setActive('generales')">
      Permisos generales
    </button>
  </div>

  <!-- Contenido derecho -->
  <div class="flex-1 p-8 overflow-auto">
    <nz-page-header class="text-[16px] font-semibold p-0 m-0"
      [nzTitle]="
        activeSection === 'usuario' ? 'Permisos por usuario' :
        activeSection === 'perfil' ? 'Permisos por perfil' :
        'Permisos generales'
      ">
    </nz-page-header>
 <nz-page-header class="text-[16px] font-semibold p-0 pb-2 m-0" nzTitle="Configuración del sistema">
        <nz-page-header-extra class="flex items-center gap-4">
                <button *ngIf="activeSection === 'usuario' && selectedItem" class="button primary-button" type="button" (click)="openAddPermissionModal()">
                    <div class="flex items-center">
                        <span style="filter: invert(1); font-size: 14px; font-weight: bold;">+</span>&nbsp;
                        Añadir permiso
                    </div>
                </button>
                <button class="button primary-button" type="button" (click)="savePermissions()">
                    <div class="flex items-center">
                        <img src="assets/icons/save-icon.svg" class="h-4 w-4" style="filter: invert(1);">&nbsp;
                        Guardar
                    </div>
                </button>
        </nz-page-header-extra>
    </nz-page-header>
    <nz-divider></nz-divider>

    <!-- Buscador visible solo para usuario/perfil -->
    <div *ngIf="activeSection !== 'generales'" class="mb-6">
      <label class="font-semibold mr-2">
        {{ activeSection === 'usuario' ? 'Seleccionar usuario:' : 'Seleccionar perfil:' }}
      </label>
      <nz-select
        nzShowSearch
        nzPlaceHolder="Buscar..."
        style="width: 300px"
        [(ngModel)]="selectedItem"
        (ngModelChange)="onSelectionChange($event)">
        <nz-option
          *ngFor="let opt of (activeSection === 'usuario' ? users : profiles)"
          [nzValue]="opt.id"
          [nzLabel]="opt.nombre">
        </nz-option>
      </nz-select>
    </div>

    <!-- Tabla de permisos -->
    <nz-table #permissionsTable [nzData]="permissions" nzBordered [nzShowPagination]="false">
      <thead>
        <tr>
          <th>Módulo</th>
          <th>Permiso</th>
        
          <th class="text-center">
            Todo<br>
            <button nz-button nzType="link" (click)="toggleAll('toggleAll')">Activar todo</button>
          </th>
          <th class="text-center">
            Leer<br>
            <button nz-button nzType="link" (click)="toggleAll('leer')">Activar todo</button>
          </th>
          <th class="text-center">
            Crear<br>
            <button nz-button nzType="link" (click)="toggleAll('crear')">Activar todo</button>
          </th>
          <th class="text-center">
            Escribir<br>
            <button nz-button nzType="link" (click)="toggleAll('escribir')">Activar todo</button>
          </th>
          <th class="text-center">
            Eliminar<br>
            <button nz-button nzType="link" (click)="toggleAll('eliminar')">Activar todo</button>
          </th>
          <th *ngIf="activeSection === 'usuario'" class="text-center">
            Acción<br>
            <button nz-button nzType="link" style="color: #ef4444;" (click)="deleteAllUserPermissions()">Eliminar todo</button>
          </th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let p of permissions">
          <td>{{ p.mainkey }}</td>
          <td>{{ p.key }}</td>
          <td class="text-center">
            <nz-switch [(ngModel)]="p.toggleAll" (ngModelChange)="toggleRow(p)"></nz-switch>
          </td>
          <td class="text-center"><nz-switch [(ngModel)]="p.leer"></nz-switch></td>
          <td class="text-center"><nz-switch [(ngModel)]="p.crear"></nz-switch></td>
          <td class="text-center"><nz-switch [(ngModel)]="p.escribir"></nz-switch></td>
          <td class="text-center"><nz-switch [(ngModel)]="p.eliminar"></nz-switch></td>
          <td *ngIf="activeSection === 'usuario'" class="text-center">
            <button class="button" style="background-color: #ef4444; color: white;" type="button" (click)="deleteUserPermission(p)">
              Eliminar
            </button>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </div>
</div>
